export default function Testimonials() {
  return (
    <>
      <section className="section" id="testimonials">
        <div className="container">
          <p className="section-eyebrow">Loved by riders</p>
          <h2 className="section-title">What our riders say</h2>
          <div className="testimonial-slider">
            <div className="testimonial-track" id="testimonialTrack">
              <div className="testimonial-card">
                <p className="stars">★★★★★</p>
                <p className="quote">
                  "Booked a single seat from Lucknow to Kanpur for ₹279 —
                  cheaper than the bus and way more comfortable. Driver was on
                  time and verified."
                </p>
                <div className="testimonial-user">
                  <img src="/assets/website/images/avatar-1.svg" alt="Riya S." />
                  <div>
                    <strong>Riya S.</strong>
                    <span>Lucknow</span>
                  </div>
                </div>
              </div>
              <div className="testimonial-card active">
                <p className="stars">★★★★★</p>
                <p className="quote">
                  "We booked a full cab for a family trip to Agra. Fixed fare,
                  no last-minute surge, and the SUV was spotless."
                </p>
                <div className="testimonial-user">
                  <img src="/assets/website/images/avatar-2.svg" alt="Amit K." />
                  <div>
                    <strong>Amit K.</strong>
                    <span>Delhi</span>
                  </div>
                </div>
              </div>
              <div className="testimonial-card">
                <p className="stars">★★★★☆</p>
                <p className="quote">
                  "Live tracking gave my parents peace of mind while I travelled
                  alone at night. Support team also responded within minutes."
                </p>
                <div className="testimonial-user">
                  <img src="/assets/website/images/avatar-3.svg" alt="Neha P." />
                  <div>
                    <strong>Neha P.</strong>
                    <span>Varanasi</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="testimonial-controls">
              <button id="prevTestimonial" aria-label="Previous review">
                ←
              </button>
              <div className="testimonial-dots" id="testimonialDots">
                <span className="" />
                <span className="active" />
                <span className="" />
              </div>
              <button id="nextTestimonial" aria-label="Next review">
                →
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
